export default __webpack_public_path__ + "static/media/Blooded Straps of the Far Horizon.9b9a84f9.jpg";